// billing.constants.ts
// Single source of truth for plan pricing, features, and display info.

export const PLANS = {
  sanctum: {
    displayName: 'Sanctum',
    apiKey: 'sanctum' as const,
    pricing: {
      monthly: 2000,          // $2,000/mo
      annualMonthly: 1600,    // $1,600/mo billed annually
      annualTotal: 19200,     // $19,200/year
      annualSavings: 4800,    // save $4,800/year
    },
    features: [
      'Zero-friction prompts to surface patterns, blind spots, and leverage points',
      'Asynchronous review and insight from your personal advisor',
      'Secure, private dashboard for high-clarity decision-making',
    ],
  },
  northStar: {
    displayName: 'North Star',
    apiKey: 'north_star' as const,
    pricing: {
      monthly: 6250,          // $6,250/mo
      annualMonthly: 5000,    // $5,000/mo billed annually
      annualTotal: 60000,     // $60,000/year
      annualSavings: 15000,   // save $15,000/year
    },
    features: [
      'Zero-friction prompts to surface patterns, blind spots, and leverage points',
      'Asynchronous review and insight from your personal advisor',
      'Secure, private dashboard for high-clarity decision-making',
      'Upload and store key company data — financials, KPIs, ops reports',
      'Advisor gains full situational context to deliver sharper, more tailored guidance',
    ],
    upsellFeatures: [
      'Upload and store key company data — financials, KPIs, ops reports',
      'Advisor gains full situational context to deliver sharper, more tailored guidance',
    ],
  },
} as const;

export type PlanKey = keyof typeof PLANS;

// Convenience re-exports for backwards compatibility
export const SANCTUM_FEATURES: readonly string[] = PLANS.sanctum.features;
export const NORTH_STAR_FEATURES: readonly string[] = PLANS.northStar.features;

// Helper to format cents as dollars
export const formatDollars = (cents: number): string => {
  return `$${(cents).toLocaleString()}`;
};
